import styled from "styled-components";

export const TitleHeading = styled.h1`
  font-family: var(--altFontFamily);
  font-size: var(--heading-size-level1);
  line-height: 1;
  margin: 0;
  margin-bottom: 1em;
  text-shadow: var(--textShadow);
  color: var(--text);

  & > a {
    color: inherit;
    text-decoration: none;
  }
`;

export const HeadingSmall = styled.h2`
  font-family: var(--altFontFamily);
  font-size: var(--heading-size-level2);
  line-height: 1;
  margin: 0;
  margin-bottom: 0.5em;
  text-shadow: var(--textShadow);
  color: var(--text);
`;
